import * as matter from "gray-matter";
import type { NextPage, GetStaticProps, InferGetStaticPropsType } from "next";

import { getFooterData, FooterData } from "data/footer";

import { Markdown } from "~/components/markdown";

const MARKDOWN_FILE_PATH = "data/privacy/privacy.md";

interface StaticProps {
  footerData: FooterData;
  data: string;
}

const Privacy: NextPage<InferGetStaticPropsType<typeof getStaticProps>> = ({
  footerData,
  data,
}) => {
  return <Markdown markdownData={data} footerData={footerData} />;
};

export const getStaticProps: GetStaticProps<StaticProps> = async () => {
  const data = await matter.read(MARKDOWN_FILE_PATH);
  return {
    props: {
      footerData: getFooterData(),
      data: JSON.stringify(data),
    },
  };
};

export default Privacy;
